import { render, staticRenderFns } from "./customHome.vue?vue&type=template&id=01e85f73&scoped=true&"
import script from "./customHome.vue?vue&type=script&lang=js&"
export * from "./customHome.vue?vue&type=script&lang=js&"
import style0 from "./customHome.vue?vue&type=style&index=0&id=01e85f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e85f73",
  null
  
)

export default component.exports